var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseAttachmentError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70751 4.00008L7.85341 0.854052C8.04886 0.658759 8.04886 0.341887 7.85341 0.146595C7.65796 -0.0488649 7.34144 -0.0488649 7.14598 0.146595L4.00008 3.29263L0.854016 0.146595C0.658565 -0.0488649 0.34204 -0.0488649 0.146589 0.146595C-0.0488629 0.341887 -0.0488629 0.658759 0.146589 0.854052L3.29266 4.00008L0.146589 7.14612C-0.0488629 7.34141 -0.0488629 7.65828 0.146589 7.85357C0.244314 7.95113 0.372392 8 0.500302 8C0.628213 8 0.75629 7.95114 0.854016 7.85341L4.00008 4.70737L7.14598 7.85341C7.24371 7.95114 7.37179 8 7.4997 8C7.62761 8 7.75569 7.95114 7.85341 7.85341C8.04886 7.65811 8.04886 7.34124 7.85341 7.14595L4.70751 4.00008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAttachmentError);
export default __webpack_public_path__ + "static/media/close-attachment-error.ee89c0e4.svg";
export { ForwardRef as ReactComponent };